import React, { useState } from 'react'
import { Pencil } from 'lib/lucide'
import moment from 'moment'

import { snackbar } from 'components'
import { ERRORS } from 'consts'
import { useApi } from 'hooks'

import { getEvents } from './api'
import { Event as EventType, GetEvenstResponse } from './types'
import { DefaultTable } from '../components'
import { CreateEventDialog, UpdateEventDialog } from './components'

const Events: React.FC = () => {
  const [isCreateEventDialogOpen, setIsCreateEventDialogOpen] = useState(false)
  const [eventToUpdate, setEventToUpdate] = useState<EventType>()

  const [{ data: events, isLoading }, refetchEvents] = useApi<GetEvenstResponse, EventType[]>(
    getEvents,
    (responseData: GetEvenstResponse) => responseData?.events ?? [],
    {
      baseData: [],
      onError: () => snackbar.show(ERRORS.GENERIC_ERROR_MESSAGE),
    },
  )

  const handleCreateSuccess = () => {
    refetchEvents()
    setIsCreateEventDialogOpen(false)
  }

  const handleUpdateSuccess = () => {
    refetchEvents()
    setEventToUpdate(undefined)
  }

  const columns = [
    { title: 'ID', field: 'id' },
    { title: 'Nombre', field: 'name' },
    {
      title: 'Inicio',
      field: 'start',
      render: (rowData: EventType) => moment(rowData.start).format('DD/MM/YYYY HH:mm'),
    },
    {
      title: 'Fin',
      field: 'end',
      render: (rowData: EventType) => moment(rowData.end).format('DD/MM/YYYY HH:mm'),
    },
    {
      title: 'Activo',
      field: 'active',
      render: (rowData: EventType) => (rowData.active ? 'Si' : 'No'),
    },
  ]

  const actions = [
    {
      icon: 'add',
      tooltip: 'Nuevo evento',
      isFreeAction: true,
      onClick: () => {
        setIsCreateEventDialogOpen(true)
      },
    },
    {
      icon: () => <Pencil size={20} />,
      tooltip: 'Editar evento',
      onClick: (_: React.SyntheticEvent, row: EventType | EventType[]) => {
        setEventToUpdate(row as EventType)
      },
    },
  ]

  return (
    <>
      <DefaultTable
        title="Sorteos"
        columns={columns}
        data={events}
        isLoading={isLoading}
        actions={actions}
      />

      {isCreateEventDialogOpen && (
        <CreateEventDialog
          handleClose={() => setIsCreateEventDialogOpen(false)}
          onDone={handleCreateSuccess}
        />
      )}
      {eventToUpdate && (
        <UpdateEventDialog
          handleClose={() => setEventToUpdate(undefined)}
          event={eventToUpdate}
          onDone={handleUpdateSuccess}
        />
      )}
    </>
  )
}

export { Events }
